module.exports = __webpack_public_path__ + "img/the-netherlands-digestive-diseases-female.ecbdeb3c.png";